const locale = {
  NUMBER_4: 4,
  TITLE_PAGE_404: 'Something went',
  BOLD_TITLE_PAGE_404: 'wrong',
  SUBTITLE_PAGE_404: 'We can’t seem to find the page you are looking for.',
  HOME_BUTTON_PAGE_404: 'Go home',
};

export default locale;
